import { render, staticRenderFns } from "./OptionsCarriersAndTrucks.vue?vue&type=template&id=60a8ad76&scoped=true"
import script from "./OptionsCarriersAndTrucks.vue?vue&type=script&lang=js"
export * from "./OptionsCarriersAndTrucks.vue?vue&type=script&lang=js"
import style0 from "./OptionsCarriersAndTrucks.vue?vue&type=style&index=0&id=60a8ad76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8ad76",
  null
  
)

export default component.exports